var SCM = SCM || {};

SCM.SearchResults = {};

SCM.SearchResults.INVALID_DATE_RANGE_ERROR_ID = 'ErrorMessageInvalidDateRange';

// Renders an inline, ARIA-wired date error (WCAG 3.3.1).
// message defaults to the input's before-start message; errorRegionId defaults to the
// Left Rail error region. Advanced Search passes its own message and region id.
SCM.SearchResults.showInlineDateRangeError = function ($input, message, errorRegionId) {
    var regionId = errorRegionId || SCM.SearchResults.INVALID_DATE_RANGE_ERROR_ID;
    var errorText = message || $input.data('errorBeforeStart');
    $('#' + regionId)
        .text(errorText)
        .removeClass('sf-date-range-error--hidden');
    $input.attr('aria-invalid', 'true').attr('aria-describedby', regionId);
};

SCM.SearchResults.clearInlineDateRangeError = function ($input, errorRegionId) {
    var regionId = errorRegionId || SCM.SearchResults.INVALID_DATE_RANGE_ERROR_ID;
    $('#' + regionId)
        .text('')
        .addClass('sf-date-range-error--hidden');
    $input.removeAttr('aria-invalid').removeAttr('aria-describedby');
};

// Returns true when a date field holds an INCOMPLETE entry (missing month/day, or year-only) —
// the cases the AC requires us to block (WCAG 3.3.1). Handles both input renderings so the
// behavior is identical regardless of which type a field happens to be:
//   - Native <input type="date">: a partial entry reports an EMPTY .value but flags validity.badInput.
//   - Text input (fallback browser, or a field not rendered as date): a non-empty value that
//     isn't a complete MM/DD/YYYY or YYYY-MM-DD date is incomplete.
// A truly empty field returns false, so an unset date never blocks (it just applies no filter).
SCM.SearchResults.hasIncompleteDateEntry = function (inputEl) {
    if (!inputEl) {
        return false;
    }
    if (inputEl.validity && inputEl.validity.badInput) {
        return true;
    }
    var value = (inputEl.value || '').trim();
    if (value === '') {
        return false;
    }
    return !/^\d{1,2}[\/-]\d{1,2}[\/-]\d{4}$/.test(value) && !/^\d{4}-\d{2}-\d{2}$/.test(value);
};

SCM.SearchResults.defaults = {
    controller: 'Solr',
    action: 'SolrSearch',
    instanceName: 'SearchResults',
    baseSiteUrl: '',
    updateTargetSelector: '.content-main_content',
    onHashChange: function hashChange(dataObj) { }
};

(function (ns, $) {

    ns.AddShowMoreLinks = function () {
        var facetToggleLimit = $('#js-hf-facet-toggle-limit').val();

        if (!facetToggleLimit) {
            facetToggleLimit = 12; //original Theme js default
        }

        AddShowMoreLinksSearchFacet(facetToggleLimit);
        AddShowMoreLinksTaxonomy(facetToggleLimit);

        $(document).on('click', '.js-sri-journal-description-container a', function (e) {
            e.preventDefault();
            $(this).closest('.js-sri-journal-description-container').find('.js-sri-journal-description').toggleClass('hide');
        });
    };
    SCM.SearchResults.AddShowMoreLinks();

    function AddShowMoreLinksTaxonomy(facetToggleLimit) {
        $('.taxonomy-tree-wrap').each(function () {
            CheckForShowMoreLink($(this), facetToggleLimit, 'facetShowMoreTax');
        });

        $('.facetShowMoreTax').off('click');

        $('.facetShowMoreTax').on('click', function () {
            ShowMoreEvent($(this), facetToggleLimit, '.taxonomy-tree-wrap');
        });
    }

    function AddShowMoreLinksSearchFacet(facetToggleLimit) {
        $('.collapsible-facet .sf-facet-list').each(function () {
            var facetShowMoreToggleLimit = GetFacetToggleLimit($(this), facetToggleLimit);
            CheckForShowMoreLink($(this), facetShowMoreToggleLimit, 'facetShowMore');
        });

        $('.facetShowMore').off('click');

        $('.facetShowMore').on('click', function () {
            var facetShowMoreToggleLimit = GetFacetToggleLimit($(this), facetToggleLimit);
            ShowMoreEvent($(this), facetShowMoreToggleLimit, '.sf-facet-list');
        });
    }

    function GetFacetToggleLimit($element, globalFacetToggleLimit) {
        var facetToggleLimit = $element.data('showmoretogglelimit');

        if (!facetToggleLimit || facetToggleLimit < 1) {
            facetToggleLimit = globalFacetToggleLimit;
        }

        return facetToggleLimit;
    }

    function CheckForShowMoreLink($element, facetToggleLimit, showMoreClass) {
        if ($element.find('.sf-facet').length > facetToggleLimit) {
            $element.find('.sf-facet:gt(' + (facetToggleLimit - 1) + ')').hide();

            if (!$element.find('.facetShowMoreTax').length) {
                if (!$element.parents('.sf-facet').length) {
                    $element.append('<li><a href="javascript:;" data-showmoretogglelimit="' + facetToggleLimit + '"class="' + showMoreClass + '">Show more</a></li>');
                }
            }
        }
    }

    function ShowMoreEvent($element, facetToggleLimit, selector) {
        if ($element.closest(selector).find('.sf-facet:gt(' + (facetToggleLimit - 1) + '):visible').length) {
            $element.closest(selector).find('.sf-facet:gt(' + (facetToggleLimit - 1) + '):visible').animate({ height: 'toggle' }, 400);
            $element.text('Show more');
        }
        else {
            $element.closest(selector).find('.sf-facet').not(':visible').animate({ height: 'toggle' }, 400);
            $element.text('Show less');
        }
        event.preventDefault();
    }

    function queryBuilderVisiblility() {
        if (window.location.search.indexOf('&cqb=') >= 0) {
            $('#btnReturnAdvancedSearch').removeClass('hide');
            $('.querybuilder-wrap').addClass('hide');
        }
        var qbQueryString = $('#queryBuilderSubmit').data('currentUrl');        
        $('#btnReturnAdvancedSearch').click(function () {
            window.location.href = location.protocol + '//' + $('#hfSiteURL').val() + '/advanced-search?' + qbQueryString;
        });
    }

    queryBuilderVisiblility();

    function toggleIcon($icon) {
        $icon.hasClass('icon-general-arrow-filled-right') ?
            $icon.removeClass('icon-general-arrow-filled-right').addClass('icon-general-arrow-filled-down') :
            $icon.removeClass('icon-general-arrow-filled-down').addClass('icon-general-arrow-filled-right');
    }

    function toggleTaxonomyChildren() {
        // Taxonomy-arrow expand/collapse is handled by the disclosure-pattern click
        // handler in SCM.SearchAccessibility.js — do not re-bind it here, otherwise
        // toggleIcon() adds the icon class to the <button>, producing a second arrow
        // alongside the icon already on the nested <i>.
        $('.js-taxonomy-umbrella-toggle').on('click', function () {
            var $this = $(this);

            $('.taxonomy-tree-wrap').slideToggle();
            $icon = $this.find('.taxonomy-umbrella-arrow');
            toggleIcon($icon);
        });
    } // END: toggleTaxonomyChildren()
    toggleTaxonomyChildren(); // run the function when page loads (also called in doSolrSearch ajax below)

    var cache = {};
    //push the current state into the cache and into the history
    var initialQueryString = window.location.search.substring(1);


    window.onpopstate = function (e) {
        if (e.state && e.state.queryString) {
            SCM.SearchResults.doSolrSearch(e.state);
        }
    };

    //bind actions
    (function() {
        var $updateTarget = $(SCM.SearchResults.defaults.updateTargetSelector);

        // Since the initial load of the GeoRef map results page does an AJAX request to populate the results,
        // we don't want to cache the initial load of that particular page.
        if (!isGeoRefMapResultsPage()) {
            cache[initialQueryString] = { results: $updateTarget.html() };
        }
        window.history.replaceState({ queryString: initialQueryString }, null, null);

        //TODO: Consolidate Date functions from (AdvancedSearch.JS, AdvancedFeatureSearch.JS, and SolrSearch.CSHTML) into a new DateHelper.JS file
        var isAlertPostCompleted = true;
        //For todays date;
        // Source: http://stackoverflow.com/questions/10211145/getting-current-date-and-time-in-javascript
        Date.prototype.today = function() {
            return (this.getMonth() + 1 < 10 ? '0' : '') + (this.getMonth() + 1) + '/' + (this.getDate() < 10 ? '0' : '') + this.getDate() + '/' + this.getFullYear();
        };

        $updateTarget.on('click', '.chkSelect', function (e) {
            const $checkbox = $(this);
            SCM.SearchResults.doSolrSearch({
                queryString: $checkbox.data('redirectUrl'),
                source: 'searchresults',
                callback: function (searchResult) {
                    _handleSearchCompleteCallback($checkbox, searchResult);
                }
            });
        });
        
        $updateTarget.on('click', 'a.close', function (e) {
            var url = $(this).attr('data-url');
            if (!(url == null || url == '#')) {
                e.preventDefault();

                SCM.SearchResults.doSolrSearch({ queryString: url, source: 'searchresults' });
            }
        });


        $updateTarget.on('click', '.rbShowFacet', function(e) {
            e.preventDefault();
            var previousStatus = $(this).attr('previous-status');
            // alert(this.checked);
            // alert(previousStatus);
            if (previousStatus == 'False') {
                var dataurl = $(this).attr('data-url');
                SCM.SearchResults.doSolrSearch({ queryString: dataurl, source: 'searchresults' });
            }
        });


        $updateTarget.on('click', '#solrSearchBtn', function() {
            var queryText = $('#txtSearch').val();

            if (queryText == null || queryText == '') {
                alert('Please enter a term to perform search');
            } else {
                queryText = encodeURIComponent(queryText);
                SCM.SearchResults.doSolrSearch({ queryString: 'q=' + queryText });
            }
        });

        $updateTarget.on('click', '#btnRangeSearch', function () {
            var $fromInput = $('.js-from-date').first();
            var $endInput = $('.js-to-date').first();
            var inlineDateValidation = $endInput.data('enableInlineValidation') === true;
            var isSingleDate = $('.date-range-input-radio[value=single]').is(':checked');

            var startDate = $fromInput.val();
            var endDate = isSingleDate ? startDate : $endInput.val();

            // WCAG 3.3.1: block submission of an incomplete date (missing month/day or year-only).
            // A native date input reports an empty value for partial entry, so detect it via
            // validity.badInput and surface an inline error rather than searching unfiltered.
            if (inlineDateValidation) {
                var incompleteMessage = $endInput.data('errorIncompleteDate');
                if (SCM.SearchResults.hasIncompleteDateEntry($fromInput[0])) {
                    SCM.SearchResults.showInlineDateRangeError($fromInput, incompleteMessage);
                    return;
                }
                if (!isSingleDate && SCM.SearchResults.hasIncompleteDateEntry($endInput[0])) {
                    SCM.SearchResults.showInlineDateRangeError($endInput, incompleteMessage);
                    return;
                }
            }

            //Compare Dates
            var invertedDateRange = new Date(endDate) < new Date(startDate);
            if (invertedDateRange) {
                if (inlineDateValidation) {
                    SCM.SearchResults.showInlineDateRangeError($endInput, $endInput.data('errorBeforeStart'));
                } else {
                    alert('End Date must be greater than Start Date');
                }
                return;
            }

            SCM.SearchResults.clearInlineDateRangeError($fromInput);
            SCM.SearchResults.clearInlineDateRangeError($endInput);

            var rgurl = $(this).attr('data-url').replace('queryText', startDate + ' TO ' + endDate);
            SCM.SearchResults.doSolrSearch({ queryString: rgurl, source: 'searchresults' });
        });

        var isTrue = function (input) {
            if (typeof input == 'string') {
                return input.toLowerCase() == 'true';
            }

            return !!input;
        };

        var signUpForAlerts = function () {
            var modelValues = {
                UserEmail: $('#UserEmail').val(),
                ResourceTitle: $('#ResourceTitle').val(),
                AlertType: $('#AlertType').val(),
                CurrentUserEmail: $('#CurrentUserEmail').val(),
                IsUserAlreadySubscribed: isTrue($('#IsUserAlreadySubscribed').val()),
                SuccessfulUpdate: $('#SuccessfulUpdate').val(),
                ResourceId: $('#ResourceId').val(),
                ResourceType: $('#ResourceType').val(),
                SearchTerm: $('#SearchTerm').val(),
                SearchUrl: $('#SearchUrl').val(),
                CurrentAlertContextSiteId: $('#CurrentAlertContextSiteId').val(),
                ShowSaveSearchToUnauthenticatedUser: isTrue($('#ShowSaveSearchToUnauthenticatedUser').val()),
                UserIsLoggedIn: isTrue($('#UserIsLoggedIn').val())
            };
            if (modelValues.IsUserAlreadySubscribed != null && modelValues.IsUserAlreadySubscribed) {
                var myAccountUrl = $('#Config_SearchAlertMyAccoutUrl').val();
                window.location.href = myAccountUrl;
            } else if (modelValues.ShowSaveSearchToUnauthenticatedUser && !modelValues.UserIsLoggedIn) {
                ShowSignInForSearchAlertSignUp();
                isAlertPostCompleted = true;
            } else {
                $.post('/Toolbox/ToolboxGetAlertsUpdateMessage', modelValues, function (data) {
                    isAlertPostCompleted = true;
                    alert('Alert Saved Sucessfully. Visit My Account page to manage your email alerts');
                    // alert(data);
                    $('#divSearchAlerts').html(data);
                    $('#divSearchAlerts a').on('click', function (e) {
                        e.preventDefault();
                        signUpForAlerts();
                    });
                });
            }

        };

        $updateTarget.on('click', '#divSearchAlerts a', function(e) {
            e.preventDefault();
            //alert(isAlertPostCompleted);
            if (isAlertPostCompleted) {
                isAlertPostCompleted = false;
                signUpForAlerts();
            }
        });

    }());

    function _handleSearchCompleteCallback(source, searchResult) {
        if (typeof App?.Search?.onFacetChangeComplete === 'function') {
            App.Search.onFacetChangeComplete(source, searchResult);
        }
    }

    function isGeoRefMapResultsPage() {
        return window.location.pathname.includes('/map-results');
    }

    //add search functions to SCM.SearchResults
    SCM.SearchResults = $.extend(SCM.SearchResults, function ($, undefined) {

        var doSolrSearch = function (myobject) {
            var scrollIfNotInView = function (target) {
                var rect = target.getBoundingClientRect();

                if (rect.top < 0) {
                    $('html, body').animate({
                        scrollTop: target.offsetTop
                    }, 1000);
                }
            };

            var callback = myobject.callback;
            delete myobject.callback;

            var updateBrowserHistory = function myfunction(myobject) {

                if (window.history.state === null) {
                    window.history.replaceState(myobject,
                        null,
                        window.location.pathname + '?' + myobject.queryString);
                }
                else if (window.history.state.queryString != myobject.queryString) {
                    window.history.pushState(myobject,
                        null,
                        window.location.pathname + '?' + myobject.queryString);
                }
            };

            if ($('#hfNbnjToc').val()) {
                SCM.SearchResults.defaults
                    .updateTargetSelector = '#ContentTab';
                SCM.SearchResults.defaults
                    .isNbnj = true;
                SCM.SearchResults.defaults
                    .controller = 'Page';
                SCM.SearchResults.defaults
                    .action = 'NbnjBookSearch';
                SCM.SearchResults.defaults
                    .instanceName = 'Nbnj_BookToc';
            }

            var settings = $.extend(SCM.SearchResults.defaults, myobject);

            var $updateTarget = $(settings.updateTargetSelector);

            if (cache[myobject.queryString] && !settings.isNbnj) {
                //no need hit the server, we've run the query before in the context of this page
                $updateTarget.html(cache[myobject.queryString].results).show();
                //need to rebind things that would normall rebind after the ajax post
                SCM.SolrSearch.ajaxComplete();
                scrollIfNotInView($updateTarget[0]);
                toggleTaxonomyChildren();
                updateBrowserHistory(myobject);
                queryBuilderVisiblility();
                //Heatmap is on map-results page and source is not heatmap.
                if (myobject.hasOwnProperty('source') && isGeoRefMapResultsPage() && myobject.source !== 'heatmap') {
                    SCM.SearchMap.searchUpdated();
                }

                // Rebind the ModifySearch button on mobile, and remove the gray background
                App.SiteJS.mobileContentNav();
                $('body').removeClass('on-canvas');

                // Re-apply access icons and multi-path icons for cached results
                if (typeof SCM.SiteJS.setAccessIcons === 'function') {
                    SCM.SiteJS.setAccessIcons();
                }
                if (typeof App !== 'undefined' && App.SiteJS && typeof App.SiteJS.setupMultiPathIcons === 'function') {
                    App.SiteJS.setupMultiPathIcons();
                }

                if (typeof callback === 'function') {
                    callback($updateTarget);
                }

                return;
            }

            // Default back to Page 1 when the search has changed
            var page = SCM.JSUtility.getSearchParamByName('page');
            if (page && parseInt(page) !== 1) {
                myobject.queryString = myobject.queryString.replace('page=' + page, 'page=1');
            }

            var ajaxUrl = '/' + settings.controller + '/' + settings.action + '/' + settings.instanceName;
            if (typeof settings.baseSiteUrl !== 'undefined' && settings.baseSiteUrl !== '') {
                ajaxUrl = '//' + settings.baseSiteUrl + ajaxUrl;
            }

            // Extract dates from the query string
            var dates = myobject.queryString.match(/(\d{2})\/(\d{2})\/(\d{4})/g);
            if (dates && dates.length === 2) {
                var startDate = toSolrLocalDateTime(dates[0], true);
                var endDate = toSolrLocalDateTime(dates[1], false);

                myobject.queryString = myobject.queryString.replace(/(\d{2}\/\d{2}\/\d{4}) TO (\d{2}\/\d{2}\/\d{4})/, startDate + ' TO ' + endDate);
            }

            ajaxUrl += '?' + myobject.queryString;
            if (settings.isNbnj) {
                var bookId = $('#hfCurrentBookId').val();
                if (!ajaxUrl.includes('nbnjToc=true') && !ajaxUrl.includes('bookId=' + bookId)) {
                    ajaxUrl += '&bookId=' + bookId;
                }
            }

            //GSW-3090 - GeoRef thesaurus search - Added logic to NOT navigate away from the GeoRef page when 
            //selecting a facet, if the user is currently on the GeoRef page.
            if ($('#hdnSiteID').val() === '155' && !isGeoRefMapResultsPage()) {
                window.location.href = '?' + myobject.queryString;
            }
            else {
                $.ajax({
                    url: ajaxUrl,
                    success: function (results) {
                        $updateTarget.html(results);
                        scrollIfNotInView($updateTarget[0]);

                        cache[myobject.queryString] = {
                            results: results,
                            updateTargetSelector: settings.updateTargetSelector
                        };

                        // Rebind the ModifySearch button on mobile, and remove the gray background
                        App.SiteJS.mobileContentNav();
                        $('body').removeClass('on-canvas');

                        // Below code is to retain the viewoption selected by client
                        if (typeof clientViewOption !== 'undefined' && clientViewOption !== '') {
                            var $sriExpandedView = $('.sri-expandedView');
                            if (clientViewOption === 'Expanded') {
                                $sriExpandedView.show();
                            } else {
                                $sriExpandedView.hide();
                            }
                        }

                        toggleTaxonomyChildren();
                        updateBrowserHistory(myobject);
                        queryBuilderVisiblility();
                        //Heatmap is on map-results page and source is not heatmap.
                        if (myobject.hasOwnProperty('source') && isGeoRefMapResultsPage() && myobject.source !== 'heatmap') {
                            SCM.SearchMap.searchUpdated();
                        }

                        if (SCM.JournalCitationFilter) {
                            SCM.JournalCitationFilter.init();
                        }

                        SCM.SearchResults.AddShowMoreLinks();
                        SCM.SolrSearch.ajaxComplete();

                        if (settings.isNbnj) {
                            var $resultQueryBuilderWrap = $(results).find('.querybuilder-wrap');
                            var $targetQueryBuilderWrap = $('.querybuilder-wrap');
                            $targetQueryBuilderWrap.html($resultQueryBuilderWrap.html())
                        }

                        if (typeof callback === 'function') {
                            callback($updateTarget);
                        }
                    },
                    error: function (evt) {
                        console.error(evt);
                    }
                }); // END: ajax
            }
        }; // END: doSolrSearch(myobject)
        

        return {doSolrSearch: doSolrSearch};
    }(jQuery));

    // Function to convert date string to Solr local date format with time
    function toSolrLocalDateTime(dateString, isStartOfDay) {
        // Parse the date string
        const parts = dateString.match(/(\d{2})\/(\d{2})\/(\d{4})/);
        if (!parts) {
            throw new Error('Invalid date format');
        }

        // Construct a new date (month is 0-indexed in JavaScript Date)
        const date = new Date(
            parseInt(parts[3], 10), // year
            parseInt(parts[1], 10) - 1, // month (0-indexed)
            parseInt(parts[2], 10), // day
            isStartOfDay ? 0 : 23, // hour (start or end of day)
            isStartOfDay ? 0 : 59, // minute (start or end of day)
            isStartOfDay ? 0 : 59 // second (start or end of day)
        );

        // Format the date and time as needed
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed, add 1
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');

        // Construct a formatted local date string (YYYY-MM-DDTHH:MM:SS)
        const localDateTimeString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;

        return localDateTimeString;
    }

})(SCM.SearchResults = SCM.SearchResults || {}, jQuery);